export default function() {
  return (
    this.messageData.description != "" ||
    (this.attachFile && this.attachFile[0].size < 1024 * 1024 * 50)
  );
}
